import React from 'react';
import { useNavigate } from 'react-router-dom';
import useBreadcrumb from '../../../hooks/useBreadcrumb';
import './breadcrumb.css';

const DynamicBreadcrumb = ({ className = 'breadcrumb-container' }) => {
    const navigate = useNavigate();
    const { breadcrumbItems, loading } = useBreadcrumb();

    if (loading || breadcrumbItems.length === 0) {
        return (
            <div className={className}>
                <span className="text-secondary">Carregando...</span>
            </div>
        );
    }

    return (
        <div className={className}>
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb mb-0">
                    {breadcrumbItems.map((item, index) => (
                        <li 
                            key={index} 
                            className={`breadcrumb-item ${item.isActive ? 'active' : ''}`}
                        >
                            {item.isActive ? (
                                <span>{item.label}</span>
                            ) : (
                                <button 
                                    className="btn btn-link p-0 text-decoration-none"
                                    onClick={() => navigate(item.path)}
                                    style={{
                                        fontSize: 'inherit',
                                        lineHeight: 'inherit',
                                        border: 'none',
                                        background: 'none'
                                    }}
                                >
                                    {item.label}
                                </button>
                            )}
                        </li>
                    ))}
                </ol>
            </nav>
        </div>
    );
};

export default DynamicBreadcrumb;
